import { reactive } from 'vue';
import { isString } from './utils';
export const state = reactive({
    keycloak: undefined,
    isAuthenticated: false,
    hasFailed: false,
    error: null,
    isPending: false,
    token: '',
    decodedToken: {},
    username: '',
    userId: '',
    roles: [],
    resourceRoles: {},
});
export const setKeycloak = (value) => {
    state.keycloak = value;
};
export const setToken = (token, tokenParsed) => {
    state.token = token;
    const content = tokenParsed;
    state.decodedToken = content;
    state.roles = content.realm_access ? content.realm_access.roles : [];
    state.username = content.preferred_username;
    state.userId = content.sub;
    state.resourceRoles = content.resource_access
        ? Object.fromEntries(Object.entries(content.resource_access).map(([key, value]) => [key, value.roles]))
        : {};
};
export const hasFailed = (value, err) => {
    state.hasFailed = value;
    if (err instanceof Error) {
        state.error = err;
    }
    else if (isString(err === null || err === void 0 ? void 0 : err.error)) {
        state.error = new Error(err.error);
    }
    else if (isString(err)) {
        state.error = new Error(err);
    }
    else {
        state.error = new Error('Unknown');
    }
    state.error.name = '[vue-keycloak]';
    console.error(state.error);
};
export const isPending = (value) => {
    state.isPending = value;
};
export const isAuthenticated = (value) => {
    state.isAuthenticated = value;
};
//# sourceMappingURL=state.js.map